const newsData = [
  {
    id: "inclusivity-message",
    title: "Fostering Inclusivity in European Dialogue",
    date: "April 25, 2025",
    summary:
      "The conference emphasized unity, inclusion, and cross-border understanding. Key speakers highlighted the importance of embracing diversity.",
  },
  {
    id: "youth-voices",
    title: "Youth Voices Leading Tomorrow’s Change",
    date: "April 20, 2025",
    summary:
      "A dedicated panel gave young leaders a voice to speak on innovation, environmental responsibility, and the future of diplomacy.",
  },
];

export default newsData;
